export default "__VITE_ASSET__CrywlFsy__"